import React, { Fragment } from 'react';
import {
  Box,
  Button,
  // Container,
  // Divider,
  Paper,
  Typography,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import ReimbursementsActions from '../../redux/reducers/reimbursements_list_reducer/actions';
import useStyles from './styles';
import ReimbursementsDatatableList from './components/datatable';
import clsx from 'clsx';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { Translations } from './configuration';
import { ReimbursementsTableDefaultFetchValues } from './components/datatable/configuration';
import NavigationConfig from 'navigation/config';
import ReimbursementsListActions from 'redux/reducers/reimbursements_list_reducer/actions';
import useQuery from 'custom_hooks/useQuery';
import BaseModal from 'components/molecules/base_modal';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import EditReimburseInfoForm from './components/edit_reimburse_info';

const ReimbursementsPage = (props: any) => {
  // console.log('Render Reimbursements Page');
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const schemeType = query.get('schemeType');
  const isPendingStr = query.get('isPending');
  const isPending = isPendingStr && isPendingStr === 'true' ? true : false;
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(schemeType && { schemeType }),
    ...(isPending && { isPending }),
  };

  React.useEffect(() => {
    dispatch(ReimbursementsActions.fetchUnreadNotificationCountAction());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      ReimbursementsActions.fetchReimbursementsListAction({
        sortField: ReimbursementsTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page: ReimbursementsTableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize: ReimbursementsTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order: ReimbursementsTableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  return (
    /*================== Reimbursements Page ==================*/
    <div>
      {/*================== Reimbursements Page - Header ==================*/}
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        {/* Reimbursements Page - Header - Title, Icon & Actions */}
        <Box display="flex" alignItems={'center'}>
          {/* Icon */}
          <CreditCardIcon style={{ marginRight: '.75rem' }} />
          {/* Title */}
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>
      {/*--------------- end of Reimbursements Page - Header ---------------*/}

      {/*================== Reimbursements Page - Body ==================*/}
      <div style={{ padding: 12 }}>
        {/*================== Reimbursements Page - Body - Reimbursements Section ==================*/}
        <div className={classes.cardLayout}>
          {/* Reimbursements Page - Body - Reimbursements Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.title}
              defaultText={Translations.title.English}
            />
          </Typography>

          {/* Reimbursements Page - Body - Reimbursements Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.description}
              defaultText={Translations.description.English}
            />
          </Typography>

          {/* Reimbursements Page - Body - Reimbursements Section - Reimbursements List Table */}
          <div className={classes.tableList}>
            <ReimbursementsDatatableList />
          </div>

          {/* Reimbursements Page - Body - Reimbursements Section - Buttons & Actions */}
          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
        {/*--------------- end of Reimbursements Page - Body - Reimbursements Section ---------------*/}
      </div>
      <Modals />
      {/*--------------- end of Reimbursements Page - Body ---------------*/}
    </div>
    /*--------------- end of Reimbursements Page ---------------*/
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      style={{ color: '#e6e6e6', backgroundColor: '#25262d' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

const Modals = () => {
  return (
    <Fragment>
      <BaseModal
        modalID={ModalIDs.MODAL_UPDATE_REIMBURSE_INFO}
        renderHeader={() => (
          <TranslatedText textMap={Translations.reimburse_info} />
        )}
        renderContent={(props) => <EditReimburseInfoForm {...props} />}
      />
    </Fragment>
  );
};

export default withRouter(ReimbursementsPage);
